import { React, useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import TokenService from '../../services/TokenService'
import { useSnackbar } from 'notistack';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';
import Skeleton from '@mui/material/Skeleton';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocationOnIcon from '@mui/icons-material/LocationOn';


import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import LoadingIndicator from '../LoadingIndicator'
import AlertDialog from '../Modals/AlertDialog';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function AddEditOrganization(props) {
    var utc = require('dayjs/plugin/utc');
    dayjs.extend(utc);
    var duration = require('dayjs/plugin/duration');
    dayjs.extend(duration);
    var relativeTime = require('dayjs/plugin/relativeTime');
    dayjs.extend(relativeTime);

    const [organization, setOrganization] = useState(props.organization);
    const [newZips, setNewZips] = useState([]);
    const [selectedTab, setSelectedTab] = useState('1');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [validationErrors, setValidationErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showAlertDialog, setShowAlertDialog] = useState(null);

    useEffect(() => {
        // set defaults if applicable
        if (props.organization.CompanyName === undefined) {
            var temp = cloneDeep(organization);
            temp.CompanyType = 'NonProfit';
            temp.PaymentMethod = 'DIGITAL CHECK';
            setOrganization(temp);
        }
    }, []);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    function handlePropChanged(val, prop) {
        let temp = cloneDeep(organization);
        temp[prop] = val;
        setOrganization(temp);
    }

    function buildContactSection() {
        return <>
          
            <Table aria-label="organization info table" className='TableRecyclerItem'>
                <TableBody>
                    <TableRow>
                        <TableCell>Type</TableCell>
                        <TableCell>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                
                                value={organization.CompanyType == undefined ? 'NonProfit' : organization.CompanyType}
                                onChange={(e) => handlePropChanged(e.target.value, 'CompanyType')}
                            >
                                <MenuItem value={'NonProfit'}>Charity</MenuItem>
                                <MenuItem value={'Fundraiser'}>Fundraiser</MenuItem>
                                <MenuItem value={'For Profit'}>For Profit</MenuItem>
                            </Select>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Donation Title:</TableCell>
                        <TableCell><TextField value={organization.DonationTitle} onChange={(e) => handlePropChanged(e.target.value, 'DonationTitle')} error={validationErrors.DonationTitle !== undefined} /></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Company Name:</TableCell>
                        <TableCell><TextField value={organization.CompanyName} onChange={(e) => handlePropChanged(e.target.value, 'CompanyName')} error={validationErrors.CompanyName !== undefined} /></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Email:</TableCell>
                        <TableCell><TextField value={organization.CompanyEmail} onChange={(e) => handlePropChanged(e.target.value, 'CompanyEmail')} error={validationErrors.CompanyEmail !== undefined} /></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Website:</TableCell>
                        <TableCell><TextField value={organization.Website} onChange={(e) => handlePropChanged(e.target.value, 'Website')} error={validationErrors.Website !== undefined} /></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>
                            <TextField value={organization.CompanyAddress} onChange={(e) => handlePropChanged(e.target.value, 'CompanyAddress')} error={validationErrors.CompanyAddress !== undefined} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Address 2</TableCell>
                        <TableCell>
                            <TextField value={organization.CompanyAddress2} onChange={(e) => handlePropChanged(e.target.value, 'CompanyAddress2')} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>City</TableCell>
                        <TableCell>
                            <TextField value={organization.CompanyCity} onChange={(e) => handlePropChanged(e.target.value, 'CompanyCity')} error={validationErrors.CompanyCity !== undefined} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>State</TableCell>
                        <TableCell>
                            <TextField value={organization.CompanyState} onChange={(e) => handlePropChanged(e.target.value, 'CompanyState')} error={validationErrors.CompanyState !== undefined} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Zipcode</TableCell>
                        <TableCell>
                            <TextField value={organization.CompanyZipcode} onChange={(e) => handlePropChanged(e.target.value, 'CompanyZipcode')} error={validationErrors.CompanyZipcode !== undefined} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Company Description</TableCell>
                        <TableCell>
                            <TextField multiline rows={4} value={organization.CompanyDescription} onChange={(e) => handlePropChanged(e.target.value, 'CompanyDescription')} error={validationErrors.CompanyZipcode !== undefined} />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    }

    function buildFinanceSection() {
        return <>

            <Table aria-label="organization info table" className='TableRecyclerItem'>
                <TableBody>
                    <TableRow>
                        <TableCell>Payment Method:</TableCell>
                        <TableCell>
                           
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                defaultValue={'DIGITAL CHECK'}
                                value={organization.PaymentMethod}
                                onChange={(e) => handlePropChanged(e.target.value, 'PaymentMethod')}
                            >
                                <MenuItem value={'DIGITAL CHECK'}>Digital Check</MenuItem>
                                <MenuItem value={'MAILED CHECK'}>Mailed Check</MenuItem>
                                <MenuItem value={'ACH'}>ACH</MenuItem>
                            </Select>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Payee Name:</TableCell>
                        <TableCell><TextField value={organization.PayeeName} onChange={(e) => handlePropChanged(e.target.value, 'PayeeName')} /></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Check Memo:</TableCell>
                        <TableCell><TextField value={organization.Memo} onChange={(e) => handlePropChanged(e.target.value, 'Memo')} /></TableCell>
                    </TableRow>
                    {organization.PaymentMethod != 'ACH' ? null :
                        <>
                            <TableRow>
                                <TableCell>ACH Routing Number</TableCell>
                                <TableCell>
                                    <TextField value={organization.ACH_RoutingNumber} onChange={(e) => handlePropChanged(e.target.value, 'ACH_RoutingNumber')} error={validationErrors.ACH_RoutingNumber !== undefined} />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>ACH Account Number</TableCell>
                                <TableCell>
                                    <TextField value={organization.ACH_AccountNumber} onChange={(e) => handlePropChanged(e.target.value, 'ACH_AccountNumber')} error={validationErrors.ACH_AccountNumber !== undefined} />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>ACH Account Type</TableCell>
                                <TableCell>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={'Checking'}
                                        value={organization.ACH_AccountType}
                                        onChange={(e) => handlePropChanged(e.target.value, 'ACH_AccountType')}
                                    >
                                        <MenuItem value={'Checking'}>Checking</MenuItem>
                                        <MenuItem value={'Savings'}>Savings</MenuItem>
                                    </Select>
                                </TableCell>
                            </TableRow>
                        </>
                    }
                    <TableRow>
                        <TableCell>TAG:</TableCell>
                        <TableCell> <TextField value={organization.QuickAccessTag} onChange={(e) => handlePropChanged(e.target.value, 'QuickAccessTag')} error={validationErrors.QuickAccessTag !== undefined} /></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    }

    function buildZipcodesSection() {
        return (<div>
            <div><Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={() => handleAddBlankZip()}><AddIcon /></Fab></div>
            {newZips.map((item, index) => {
                return <div style={{ padding: '5px', borderTop: '1px solid #d5d5d5', display: 'flex', justifyContent: 'space-between' }}>
                    <TextField inputProps={{ maxLength: 5 }} value={item} onChange={(e) => handleBlankZipChanged(e, index)} />
                    <Fab size={'small'} onClick={() => handleDeleteNewZip(index)}><DeleteIcon sx={{ color: 'var(sipzee-red)' }} /></Fab>
                </div>
                })
            }
            
            {organization.Zipcodes == null ? null : organization.Zipcodes.map((zip) => {
                return <div style={{ padding: '5px', borderTop: '1px solid #d5d5d5', display:'flex', justifyContent:'space-between' }}>
                    {zip}
                    <Fab size={'small'} onClick={() => handleDeleteZip(zip)}><DeleteIcon sx={{ color: 'var(sipzee-red)' }} /></Fab>
                </div>
            })
        }
        </div>)
    }

    function handleAddBlankZip() {
        let temp = cloneDeep(newZips);
        temp.unshift('');
        setNewZips(temp);
        
    }

    function handleDeleteNewZip(index) {
        let temp = cloneDeep(newZips);
        temp.splice(index, 1);
        setNewZips(temp);
    }

    function handleBlankZipChanged(e, index) {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            
            let temp = cloneDeep(newZips);
            temp[index] = e.target.value;
            setNewZips(temp);
        }

       
    }

    function handleDeleteZip(zip) {
        let temp = cloneDeep(organization);
        for (let i = 0; i < temp.Zipcodes.length; i++) {
            if (temp.Zipcodes[i] == zip) {
                temp.Zipcodes.splice(i, 1);
                break;
            }
        }
        setOrganization(temp);

    }

    function validateAndSave() {
        let isValid = true;
        let errors = {};

        let hasContactTabErrors = [];
        let hasFinanceTabErrors = [];
        let hasZipcodeTabErrors = [];
        

        if (organization.DonationTitle ==  undefined || organization.DonationTitle.trim() == '') {
            isValid = false;
            errors.DonationTitle = 'Required';
            hasContactTabErrors.push('Donation Title Missing');
        }

        if (organization.CompanyName == undefined || organization.CompanyName.trim() == '') {
            isValid = false;
            errors.CompanyName = 'Required';
            hasContactTabErrors.push('Company Name Missing');
        }

        if (organization.CompanyEmail == undefined || organization.CompanyEmail.trim() == '') {
            isValid = false;
            errors.CompanyEmail = 'Required';
            hasContactTabErrors.push('Company Email Missing');
        }

        if (organization.CompanyAddress == undefined || organization.CompanyAddress.trim() == '') {
            isValid = false;
            errors.CompanyAddress = 'Required';
            hasContactTabErrors.push('Address Missing');
        }

        if (organization.CompanyCity == undefined || organization.CompanyCity.trim() == '') {
            isValid = false;
            errors.CompanyCity = 'Required';
            hasContactTabErrors.push('City Missing');
        }

        if (organization.CompanyState == undefined || organization.CompanyState.trim() == '') {
            isValid = false;
            errors.CompanyState = 'Required';
            hasContactTabErrors.push('State Missing');
        }

        if (organization.CompanyZipcode == undefined || organization.CompanyZipcode.trim() == '') {
            isValid = false;
            errors.CompanyZipcode = 'Required';
            hasContactTabErrors.push('Company Zipcode Missing');
        }

        if (organization.PaymentMethod == 'ACH') {
            if (organization.ACH_AccountNumber == undefined || organization.ACH_AccountNumber.trim() == '') {
                isValid = false;
                errors.ACH_AccountNumber = 'ACH_AccountNumber';
                hasFinanceTabErrors.push('ACH Account Number missing');
            }

            if (organization.ACH_RoutingNumber == undefined || organization.ACH_RoutingNumber.trim() == '') {
                isValid = false;
                errors.ACH_RoutingNumber = 'ACH_RoutingNumber';
                hasFinanceTabErrors.push('ACH Routing Number missing');

            }

            if (organization.ACH_AccountType == undefined || organization.ACH_AccountType.trim() == '') {
                isValid = false;
                errors.ACH_AccountType = 'ACH_AccountType';
                hasFinanceTabErrors.push('ACH Account Type missing');
            }
        }

        if (organization.QuickAccessTag == undefined || organization.QuickAccessTag.trim() == '') {
            isValid = false;
            errors.QuickAccessTag = 'Required';
            hasFinanceTabErrors.push('Donation Tag Missing');
        }

        if (organization.Zipcodes == undefined) {
            organization.Zipcodes = [];
        }
        // get unique zipcodes
        for (let i = 0; i < newZips.length; i++) {
            if (newZips[i].length == 5) {
                organization.Zipcodes.push(newZips[i]);
            }
        }
        let uniqueZips = [...new Set(organization.Zipcodes)]; // removes duplicates
        organization.Zipcodes = uniqueZips;

        if (organization.Zipcodes.length == 0) {
            isValid = false;
            hasZipcodeTabErrors.push('No Zips found');
        }

        setValidationErrors(errors);

        if (isValid) {
            //if (organization.Zipcodes == undefined) {
            //    organization.Zipcodes = [];
            //}
            //// get unique zipcodes
            //for (let i = 0; i < newZips.length; i++) {
            //    if (newZips[i].length == 5) {
            //        organization.Zipcodes.push(newZips[i]);
            //    }
            //}
            //let uniqueZips = [...new Set(organization.Zipcodes)]; // removes duplicates
            //organization.Zipcodes = uniqueZips;

            // add/update

            let postData = {
                donationConfiguration: JSON.stringify(organization)
            }
            setIsLoading(true);
            TokenService.adminServicePost(postData, 'Donation_Configuration_Save')
                .then((response) => {
                    setIsLoading(false);
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let updatedOrg = JSON.parse(response.JsonData);
                        props.onSave(updatedOrg);
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Error in Todays Counts', {
                        variant: 'error',
                    });
                    setIsLoading(false);
                });
        }
        else {

            let contactMessage = null;
            let financeMessage = null;
            let zipcodesMessage = null;

            if (hasContactTabErrors.length > 0) {
                contactMessage =
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ fontWeight: 'bold' }}>Contact Tab Errors</div>
                        {
                            hasContactTabErrors.map((msg, i) => {
                                return <div key={'contactError' + i} >{msg}</div>
                            })
                        }
                    </div>
            }

            if (hasFinanceTabErrors.length > 0) {
                financeMessage =
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ fontWeight: 'bold' }}>Finance Tab Errors</div>
                        {
                            financeMessage = hasFinanceTabErrors.map((msg, i) => {
                                return <div key={'financeError' + i}>{msg}</div>
                            })
                        }
                    </div>
            }

            if (hasZipcodeTabErrors.length > 0) {
                zipcodesMessage =
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ fontWeight: 'bold' }}>Zipcodes Tab Errors</div>
                        {
                            zipcodesMessage = hasZipcodeTabErrors.map((msg, i) => {
                                return <div key={'zipcodesError' + i}>{msg}</div>
                            })
                        }
                    </div>
            }

            let message = <div>{contactMessage}{financeMessage}{zipcodesMessage}</div>;

            setShowAlertDialog({
                Title: 'Validation Errors',
                Message: message,
                CloseText: 'Close'
            })
        }
    }

    function showLoading() {
        return (<div style={{minWidth:'330px', minHeight:'500px', display:'flex', flexDirection:'column', justifyContent:'center'} }>
            <LoadingIndicator Message='Saving' />
        </div>)
    }

    return (<div componentname='AddEditOrganization' style={{ backgroundColor: '#efefef', padding: '10px', maxWidth: '95vw', flexWrap: 'wrap' }}>
        {isLoading ?
            showLoading() :
            <>
                <TabContext value={selectedTab} >
                    <TabList
                        className="AdminTabHeader"
                        variant="fullWidth"
                        textColor="primary"
                        indicatorColor="secondary"
                        onChange={handleTabChange} aria-label="Admin Tabs">
                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><span className='AdminTabText'><ContactPhoneIcon sx={{ color: 'var(--sipzee-green)', alignSelf: 'center' }} /> Contact</span></div>}
                            value="1" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><span className='AdminTabText'><MonetizationOnIcon sx={{ color: 'var(--sipzee-green)', alignSelf: 'center' }} /> Finance</span></div>}
                            value="2" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><span className='AdminTabText'><LocationOnIcon sx={{ color: 'var(--sipzee-green)', alignSelf: 'center' }} /> Zipcodes</span></div>}
                            value="3" />
                    </TabList>

                    <TabPanel value="1" style={{ padding: '10px' }}>
                        {buildContactSection()}
                    </TabPanel>
                    <TabPanel value="2" style={{ padding: '5px' }}>
                        {buildFinanceSection()}
                    </TabPanel>
                    <TabPanel value="3" style={{ padding: '10px' }}>
                        {buildZipcodesSection()}
                    </TabPanel>
                </TabContext>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '25px' }}>
                    <Button variant='outlined' onClick={() => props.onClose()}>Cancel</Button>
                    <Button variant='outlined' onClick={() => validateAndSave()} style={{ backgroundColor: 'var(--sipzee-green)' }}>Save</Button>
                </div>
                {showAlertDialog === null ? null :
                    <>
                    <Dialog
                        open={true}
                            onClose={(e) => setShowAlertDialog(null)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {showAlertDialog.Title}
                        </DialogTitle>
                        <DialogContent>
                            {showAlertDialog.Message}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={(e) => setShowAlertDialog(null)} autoFocus>
                                {showAlertDialog.CloseText}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    </>
                  
                }
            </>
        }
        

    </div>)

} export default AddEditOrganization;